import { useEffect } from "react";

export const useDeviceId = () => {
  useEffect(() => {
    const script = createScript();
    return () => document.body.removeChild(script);
  }, []);

  const createScript = () => {
    const script = document.createElement("script");
    script.src = "https://www.mercadopago.com/v2/security.js";
    script.setAttribute("view", "checkout");
    script.setAttribute("output", "deviceId");
    document.body.appendChild(script);
    return script;
  };

  const getDeviceId = () => {
    return window.deviceId;
  };

  return { getDeviceId };
};
